export default {
  name: 'marking--nkRequestCustomLoadEdit',
  apiService: 'shoes',
  apiPath: '/admin/nk_request_h/uploadCustom',
  urlParamName: 'marking--nkRequestCustomLoadEdit',
};
